// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__bGswx","title":"ClientInsurance_title__1_ylX","itemText":"ClientInsurance_itemText__3tojh"};